import React, {useContext, useEffect, useState} from "react";
import headerMenu from "../../../config/HeaderMenu";
import SvgChevron from "../../../components/ui/icons/SvgChevron";
import {Link} from "gatsby";
import './drawerMenu.scss';
import {animated, useSpring} from "@react-spring/web";
import {useTranslation} from "gatsby-plugin-react-i18next";
import DrawerMenuContext from "../../../services/hooks/DrawerMenuContext";

interface Props {
    menuItem: string,
}

const DrawerMenuItem = ({
    menuItem,
                        }: Props) => {
    const {t} = useTranslation('common');
    const {
        closeMenu,
    } = useContext(DrawerMenuContext);
   const menu = headerMenu[menuItem];
   const [submenuOpen, setSubmenuOpen] = useState<boolean>(false);
   const toggleSubmenu = () => setSubmenuOpen(open => !open);

    const [animationStyle, api] = useSpring(() => ({
        from: {
            maxHeight: 0,
        },
    }), []);

    useEffect(() => {
        if(submenuOpen)showSubmenu();
        else hideSubmenu();
    }, [submenuOpen]);

    const showSubmenu = () => {
        api.start({
            to: {
                maxHeight: 400,
            },
        })
    };

    const hideSubmenu = () => {
        api.start({
            to: {
                maxHeight: 0,
            },
        })
    };

    if(Object.keys(menu?.routes ?? {})?.length > 0){
        return (
            <div className="subListMenu" key={menuItem}>
                <div className="drawerMenuItem" role='button' onClick={toggleSubmenu}>
                    <h3>{`${menu.emoji} ${t(menu.title)}`}</h3>
                    <SvgChevron direction={submenuOpen ? 'bottom': 'right'} />
                </div>
                <animated.div
                    style={animationStyle}
                >
                    {
                        Object.keys(menu?.routes ?? {}).map(routeKey => {
                            const route = menu?.routes?.[routeKey];
                            if(!!route?.pdf){
                              return (
                                <a
                                  rel="noopener noreferrer"
                                  href={route?.pdf}
                                  onClick={closeMenu}
                                  className={["drawerMenuItem", "subMenuItem"].join(' ')}
                                  key={routeKey}
                                >
                                  <h3>{t(route?.title)}</h3>
                                  <SvgChevron />
                                </a>
                              );
                            }
                            if(!route?.route) return ;
                            if(route?.route?.includes('http')){
                                return (
                                    <a
                                        href={route?.route}
                                        onClick={closeMenu}
                                        className={["drawerMenuItem", "subMenuItem"].join(' ')}
                                        key={routeKey}
                                    >
                                        <h3>{t(route?.title)}</h3>
                                        <SvgChevron />
                                    </a>
                                )
                            }
                            return (
                                <Link
                                    to={route?.route}
                                    onClick={closeMenu}
                                    className={["drawerMenuItem", "subMenuItem"].join(' ')}
                                    key={routeKey}
                                >
                                    <h3>{t(route?.title)}</h3>
                                    <SvgChevron />
                                </Link>
                            );
                        })
                    }
                </animated.div>
            </div>
        );
    }
    if(!menu?.route || menu?.route?.length <= 0) return null;
    if(menu?.route?.includes('http')){
        return (
            <a
                href={menu?.route}
                className="drawerMenuItem"
                onClick={closeMenu}
                key={menu?.route}
            >

            </a>
        );
    }

    return (
        <Link
            to={menu.route}
            className="drawerMenuItem"
            onClick={closeMenu}
            key={menu?.route}
        >
            <h3>{`${menu.emoji} ${t(menu.title)}`}</h3>
            <SvgChevron />
        </Link>
    );
};

export default DrawerMenuItem;